@if (config) {
    <div>
        @if (!config.hideToolbar) {
            <div class="detail-page-action-bar flex-action-bar">
                <div class="buttons">
                    @for (btn of config.buttons; track btn) {
                        <button
                            class="btn btn-cerrix"
                            (click)="btn.click(config.items, btn)"
                            [disabled]="btn.disabled"
                        >
                            @if (btn.icon) {
                                <i [class]="btn.icon"></i>
                            }
                            <span>{{ btn.prettyName }}</span>
                        </button>
                    }
                </div>

                <div class="workflow-area">
                    <button (click)="toggleAll(true)" class="btn btn-dark">
                        <i class="fas fa-check-square"></i>
                        <span class="ms-2">{{
                            'selectAll' | t
                        }}</span>
                    </button>

                    <button (click)="toggleAll(false)" class="btn btn-dark">
                        <i class="fas fa-square"></i>
                        <span class="ms-2">{{
                            'deselectAll' | t
                        }}</span>
                    </button>
                </div>
            </div>
        }

        @if (config.filters && config.filters.length > 0) {
            <div class="row filters">
                @for (filter of config.filters; track filter) {
                    <div class="form-group col">
                        <label>{{ filter.prettyName }}</label>
                        @switch (filter.filterType) {
                            @case (filterTypes.Date) {
                                <date-input
                                    [(value)]="filter.value"
                                    (valueChange)="filterChanged()"
                                ></date-input>
                            }
                            @case (filterTypes.SingleSelect) {
                                <ng-select
                                    [multiple]="false"
                                    [closeOnSelect]="true"
                                    [items]="filter.data"
                                    [(ngModel)]="filter.value"
                                    (change)="filterChanged()"
                                >
                                    <ng-template
                                        ng-multi-label-tmp
                                        let-items="items"
                                        let-clear="clear"
                                    >
                                        @if (items.length > 0) {
                                            <div class="ng-value">
                                                <span class="ng-value-label"
                                                    >{{
                                                        'selectedCount'
                                                            | t: { count: items.length }
                                                    }}</span
                                                >
                                            </div>
                                        }
                                    </ng-template>
                                </ng-select>
                            }
                            @case (filterTypes.MultiSelect) {
                                <ng-select
                                    [multiple]="true"
                                    [closeOnSelect]="false"
                                    [items]="filter.data"
                                    [(ngModel)]="filter.value"
                                    (change)="filterChanged()"
                                >
                                    <ng-template
                                        ng-multi-label-tmp
                                        let-items="items"
                                        let-clear="clear"
                                    >
                                        @if (items.length > 0) {
                                            <div class="ng-value">
                                                <span class="ng-value-label"
                                                    >{{
                                                        'selectedCount'
                                                            | t: { count: items.length }
                                                    }}</span
                                                >
                                            </div>
                                        }
                                    </ng-template>
                                </ng-select>
                            }
                        }
                    </div>
                }
            </div>
        }

        @if (config.items) {
            <div class="row items">
                @for (
                    item of config.items;
                    track trackByParentIdentifier.bind(this)($index, item)
                ) {
                    <div
                        class="detail-page-card mb-3 col-12 col-lg-6 col-xxl-4"
                        [hidden]="item.hide"
                    >
                        <div
                            class="detail-page-card-title text-truncate"
                            [matTooltip]="item[config.headerProp]"
                        >
                            {{ item[config.headerProp] }}
                        </div>
                        <div class="detail-page-card-body padded">
                            <div class="overview-table">
                                @for (ovProp of config.overviewProperties; track ovProp) {
                                    <div class="overview-row">
                                        <div class="overview-header">{{ ovProp.prettyName }}:</div>
                                        <div
                                            class="overview-value text-truncate"
                                            [matTooltip]="item[ovProp.propertyName]"
                                        >
                                            {{ item[ovProp.propertyName] }}
                                        </div>
                                    </div>
                                }
                            </div>
                            <div class="form-group-separator"></div>
                            <div class="row" style="margin: -7px">
                                @for (
                                    child of item[config.childProperty];
                                    track trackByChildIdentifier.bind(this)($index, child)
                                ) {
                                    <div
                                        class="text-truncate col-6 p-2"
                                        [matTooltip]="child[config.childNameProperty]"
                                        [hidden]="child.hide"
                                    >
                                        <cerrix-checkbox
                                            [label]="child[config.childNameProperty]"
                                            [(value)]="child.selected"
                                        >
                                        </cerrix-checkbox>
                                    </div>
                                }
                            </div>
                            <div class="form-group-separator"></div>
                            <div class="flex-spacing">
                                <div class="extra-toggles">
                                    @for (toggle of config.extraToggles; track toggle) {
                                        <cerrix-checkbox
                                            [label]="toggle.prettyName"
                                            [(value)]="item[toggle.propertyName]"
                                        >
                                        </cerrix-checkbox>
                                    }
                                </div>
                                <button
                                    class="btn btn-cerrix btn-sm"
                                    (click)="toggleChildren(item)"
                                >
                                    {{
                                        (item[config.childToggleProperty]
                                            ? 'deselect'
                                            : 'select'
                                        ) | t
                                    }}
                                    {{ config.childPrettyName }}
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
} @else {
    <div class="fancy-loader"></div>
}
